import type React from 'react'
import { MindMapContext, type MindMapContextValue } from './MindMapContextDef'

/**
 * Provider component for MindMapContext
 */
export const MindMapProvider: React.FC<{
  value: MindMapContextValue
  children: React.ReactNode
}> = ({ value, children }) => {
  return <MindMapContext.Provider value={value}>{children}</MindMapContext.Provider>
}
